class NewsletterArtworkRotation extends HTMLElement {
  connectedCallback() {
    this.styleSignupForm();
    this.slides = [...this.querySelectorAll('figure')];
    if (!this.slides.length) return;
    for (let index = this.slides.length - 1; index > 0; index--) {
      const other = Math.floor(Math.random() * (index + 1));
      [this.slides[index], this.slides[other]] = [this.slides[other], this.slides[index]];
    }
    this.slides.forEach((slide, index) => { slide.hidden = index !== 0; });
    this.index = 0;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.querySelector('[data-artwork-previous]').addEventListener('click', () => this.show(-1), { signal });
    this.querySelector('[data-artwork-next]').addEventListener('click', () => this.show(1), { signal });
  }

  styleSignupForm(attempt = 0) {
    const embed = this.closest('.newsletter-dialog')?.querySelector('shopify-forms-embed');
    const root = embed?.shadowRoot;

    if (!root) {
      if (attempt < 100) {
        this.formStyleTimer = window.setTimeout(() => this.styleSignupForm(attempt + 1), 100);
      }
      return;
    }

    if (root.querySelector('#kb-newsletter-form-style')) return;

    const style = document.createElement('style');
    style.id = 'kb-newsletter-form-style';
    style.textContent = `
      /* Shopify Forms renders inside a shadow root. Keep labels in a reserved
         top row for empty, typed and autofilled values alike. Class fragments
         match the app's field components without pinning its build hashes. */
      label[class*="formInputFieldLabel"] {
        top: 8px !important;
        left: 16px !important;
        transform: none !important;
        transition: none !important;
        font: 400 12px/16px 'Beausite Detail', sans-serif !important;
        color: #66675f !important;
        max-width: calc(100% - 32px) !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        z-index: 2;
      }

      input[class*="formInputField"],
      input[type="tel"],
      textarea {
        box-sizing: border-box !important;
        min-height: 60px !important;
        padding: 28px 16px 10px !important;
        font: 400 16px/22px 'Beausite Detail', sans-serif !important;
      }

      [class*="formFieldContainer"]:has(textarea)::before {
        height: 26px !important;
      }

      input,
      textarea,
      button[class*="selectToggle"] {
        border-radius: 12px !important;
      }

      button[type="submit"] {
        border-radius: 26px !important;
      }
    `;
    root.append(style);
  }

  show(step) {
    this.slides[this.index].hidden = true;
    this.index = (this.index + step + this.slides.length) % this.slides.length;
    this.slides[this.index].hidden = false;
  }

  disconnectedCallback() {
    this.controller?.abort();
    window.clearTimeout(this.formStyleTimer);
  }
}
if (!customElements.get('newsletter-artwork-rotation')) {
  customElements.define('newsletter-artwork-rotation', NewsletterArtworkRotation);
}
